import React, { Component, FormEvent } from 'react';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableParameter } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MessageUtil from '../../../../../util/MessageUtil';
import { ApiVariableParameter } from '../../../../../domain/remote/httpVariable/HttpVariableDomains';
import FormicaInput from 'components/custom/FormicaInput';
import RoleHelper from '../../../../../RoleHelper';
import { AnimatedButton } from '@trlogic/ui-pack';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiParametersCreatorComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { parameter } = this.state;
    return (
      <div className={'flex w-full gap-x-4 items-center mb-5 justify-start px-1'}>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onKeyChange(e)}
            value={parameter.key}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_key_creator_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onValueChange(e)}
            value={parameter.value}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.value', defaultMessage: 'Value' })}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_value_creator_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onDescriptionChange(e)}
            value={parameter.description}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_description_creator_input`}
          />
        </div>
        <div className={''}>
          <AnimatedButton
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onClick={this.handleSubmit}
            customSize={'sm'}
            icon={'add'}
            customType={'primary'}
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_key_add_button`}
          />
        </div>
      </div>
    );
  }

  private onKeyChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, key: e.currentTarget.value } });
  };

  private onValueChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, value: e.currentTarget.value } });
  };

  private onDescriptionChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, description: e.currentTarget.value } });
  };

  private handleSubmit = () => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
      changeApiVariableParameter,
    } = this.props;
    const { parameter } = this.state;
    if (apiVariable.parameters.find((p) => p.key === parameter.key)) {
      MessageUtil.warning({
        summary: 'Parameter with this key already exists',
        detail: <div>{apiVariable.name} can't saved.</div>,
      });
      return false;
    }
    if (parameter.key && parameter.value && parameter.key.trim().length > 0 && parameter.value.trim().length > 0) {
      apiVariable.parameters = [...apiVariable.parameters, parameter];
      changeApiVariable(apiVariable);
      changeApiVariableParameter(apiVariable);
      this.setState({ parameter: { ...this.state.parameter, key: '', value: '', description: '' } });
    } else {
      MessageUtil.error({
        summary: 'Value and key are required',
      });
    }
  };
}

interface Props extends ReduxProps {}

class State {
  parameter: ApiVariableParameter = {
    key: '',
    value: '',
    description: '',
    isActive: true,
  };
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableParameter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiParametersCreatorComponent);
